{
  "firstName": "First Name",
  "middleName": "Middle Name",
  "lastName": "Last Name",
  "dateOfBirth": "Date of Birth",
  "primaryEmail": "Email",
  "phone": "Phone",
  "physicalAddress": "Physical Address",
  "mailingAddress": "Mailing Address",
  "alternateAddress": "Alternate Address",
  "inProvinceSince": "In Province Since",
  "gender": "Gender",
  "language": "Language",
  "maritalStatus": "Marital Status",
  "numberOfDependents": "Number of Dependents",
  "citizenships": "Citizenships",
  "countryOfTaxResidence": "Country of Tax Residence",
  "taxId": "Tax ID",
  "taxIdType": "Tax ID Type",
  "taxIdDisclosed": "Tax ID Disclosed",
  "taxIdExists": "Tax ID Exists",
  "sinExists": "SIN Exists",
  "taxNumber": "Tax Number",
  "spouseTaxId": "Spouse Tax ID",
  "spouseTaxIdType": "Spouse Tax ID Type",
  "spouseTaxIdDisclosed": "Spouse Tax ID Disclosed",
  "employmentStatus": "Employment Status",
  "jobTitle": "Job Title",
  "companyType": "Company Type",
  "employerName": "Employer Name",
  "employerCompanyAddress": "Employer Address",
  "studentAreaOfStudy": "Area of Study",
  "employmentSituation": "Employment Situation",
  "employmentSituationOtherDescription": "Employment Situation (Other)",
  "annualIncomeCents": "Annual Income",
  "annualIncomeStr": "Annual Income",
  "financialLiquidAssetsCents": "Liquid Assets",
  "financialFixedAssetsCents": "Fixed Assets",
  "totalDebtCents": "Total Debt",
  "annualDebtPaymentsCents": "Annual Debt Payments",
  "sourceOfWealth": "Source of Wealth",
  "sourceOfFunds": "Source of Funds",
  "sourceOfWealthOtherDescription": "Source of Wealth (Other)",
  "sourceOfFundsOtherDescription": "Source of Funds (Other)",
  "debtAssociated": "Debt Associated",
  "uniqueCircumstances": "Unique Circumstances",
  "spouseFirstName": "Spouse First Name",
  "spouseLastName": "Spouse Last Name",
  "spouseAnnualIncomeCents": "Spouse Annual Income",
  "trustedContactPerson": "Trusted Contact Person",
  "entityName": "Entity Name",
  "typeOfTrust": "Type of Trust",
  "establishedDate": "Established Date",
  "registrationNumber": "Registration Number",
  "countryOfRegistration": "Country of Registration",
  "investmentKnowledge": "Investment Knowledge",
  "riskQuestion1": "Risk Question 1",
  "riskQuestion2": "Risk Question 2",
  "foreignTaxInformation": "Foreign Tax Information",
  "fatcaStatus": "FATCA Status",
  "fatcaStatusOtherDescription": "FATCA Status (Other)",
  "preferredMethodOfCommunication": "Preferred Method of Communication",
  "iDCheckCompleted": "ID Check Completed",
  "iDCheckRetrigger": "ID Check Retrigger",
  "iDVerified": "ID Verified",
  "complianceState": "Compliance State",
  "payTaxesOutsideCanada": "Pays Taxes outside Canada"
}
